module.exports = __webpack_public_path__ + "static/media/Brios-Frutal-Descripcion-Mobile.0b32b2c6.webp";